import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";
import { ICallOutboundPricing } from "@leedpulse-monorepo/interfaces";
import { outboundPricingVersion } from "@leedpulse-monorepo/utils";

/** Where a changed field of an Admins doc keeps its versions: `Admins/<id>/history`. */
export const ADMIN_HISTORY_SUBCOLLECTION = 'history';
export const OUTBOUND_PRICING_HISTORY_FIELD = 'telephony.call_outbound_pricing';

export interface IOutboundPricingVersion {
  id: string;
  created: number;
  author: string;
  version: string; // matches `billing.grid_version` on the calls this grid priced
  value: ICallOutboundPricing;
}

/** Every saved version of the outbound pricing grid of an admin config, newest first. */
async function getOutboundPricingHistory(adminId: string): Promise<IOutboundPricingVersion[]> {
  try {
    const snap = await getDocs(query(collection(firestore, FirestoreCollections.admins, adminId, ADMIN_HISTORY_SUBCOLLECTION), orderBy('created', 'desc')));
    return snap.docs
      .filter((entry) => entry.get('field') === OUTBOUND_PRICING_HISTORY_FIELD)
      .map((entry) => {
        const value = entry.get('value') as ICallOutboundPricing;
        // Entries saved before the version was stored get it computed: same grid, same id
        return { id: entry.id, created: entry.get('created') as number, author: (entry.get('author') as string) || '', version: (entry.get('version') as string) || outboundPricingVersion(value), value };
      });
  } catch (e) {
    console.log("error: ", e);
    throw new GetOutboundPricingHistoryFailure();
  }
}

export class GetOutboundPricingHistoryFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getOutboundPricingHistory;